import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useForm, ValidationError } from '@formspree/react';
import { ArrowLeftIcon, CheckCircleIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function FreeAssessment() {
  const navigate = useNavigate();
  const [state, handleSubmit] = useForm('xwpkglvj');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    language: '',
    currentLevel: '',
    goals: '',
    preferredSchedule: '',
    _replyto: 'thelanguagemagnateacademy@gmail.com',
    _subject: 'New Free Assessment Booking'
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  useEffect(() => {
    if (state.succeeded) {
      setFormData({
        name: '',
        email: '',
        phone: '',
        language: '',
        currentLevel: '',
        goals: '',
        preferredSchedule: '',
        _replyto: 'thelanguagemagnateacademy@gmail.com',
        _subject: 'New Free Assessment Booking'
      });
    }
  }, [state.succeeded]);
  return <div className="min-h-screen bg-gradient-to-br from-green-50 to-orange-50 py-24" data-id="element-429">
      <div className="max-w-3xl mx-auto px-6" data-id="element-430">
        <button onClick={() => navigate('/')} className="flex items-center gap-2 text-slate-700 hover:text-green-600 mb-8 transition-colors duration-200" data-id="element-431">
          <ArrowLeftIcon size={20} data-id="element-432" />
          Back to Home
        </button>
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-3xl shadow-xl p-8 md:p-12" data-id="element-433">
          <div className="text-center mb-8" data-id="element-434">
            <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4" data-id="element-435">
              Book Your <span className="text-green-600" data-id="element-436">Free Assessment</span>
            </h1>
            <p className="text-lg text-slate-600" data-id="element-437">
              Let us evaluate your current language level and create a
              personalized learning plan for you
            </p>
          </div>
          {state.succeeded ? <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} className="text-center py-12" data-id="element-438">
              <CheckCircleIcon className="text-green-600 mx-auto mb-4" size={64} data-id="element-439" />
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-440">
                Assessment Booked Successfully!
              </h2>
              <p className="text-slate-600 mb-8" data-id="element-441">
                Thank you for booking your free assessment. We'll contact you
                shortly to schedule your session.
              </p>
              <button onClick={() => navigate('/')} className="bg-green-600 text-white px-8 py-3 rounded-full font-semibold hover:bg-green-700 transition-colors duration-200" data-id="element-442">
                Return to Home
              </button>
            </motion.div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-443">
              <input type="hidden" name="_replyto" value="thelanguagemagnateacademy@gmail.com" data-id="element-444" />
              <input type="hidden" name="_subject" value="New Free Assessment Booking" data-id="element-445" />
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-446">
                <div data-id="element-447">
                  <label htmlFor="name" className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-448">
                    Full Name *
                  </label>
                  <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required disabled={state.submitting} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:border-green-600 focus:ring-2 focus:ring-green-200 transition-colors duration-200 outline-none disabled:bg-slate-100" placeholder="John Doe" data-id="element-449" />
                  <ValidationError prefix="Name" field="name" errors={state.errors} data-id="element-450" />
                </div>
                <div data-id="element-451">
                  <label htmlFor="email" className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-452">
                    Email Address *
                  </label>
                  <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required disabled={state.submitting} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:border-green-600 focus:ring-2 focus:ring-green-200 transition-colors duration-200 outline-none disabled:bg-slate-100" placeholder="john@example.com" data-id="element-453" />
                  <ValidationError prefix="Email" field="email" errors={state.errors} data-id="element-454" />
                </div>
              </div>
              <div data-id="element-455">
                <label htmlFor="phone" className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-456">
                  Phone Number *
                </label>
                <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} required disabled={state.submitting} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:border-green-600 focus:ring-2 focus:ring-green-200 transition-colors duration-200 outline-none disabled:bg-slate-100" placeholder="+234 XXX XXX XXXX" data-id="element-457" />
                <ValidationError prefix="Phone" field="phone" errors={state.errors} data-id="element-458" />
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-459">
                <div data-id="element-460">
                  <label htmlFor="language" className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-461">
                    Language of Interest *
                  </label>
                  <select id="language" name="language" value={formData.language} onChange={handleChange} required disabled={state.submitting} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:border-green-600 focus:ring-2 focus:ring-green-200 transition-colors duration-200 outline-none disabled:bg-slate-100" data-id="element-462">
                    <option value="" data-id="element-463">Select a language</option>
                    <option value="french" data-id="element-464">French</option>
                    <option value="english" data-id="element-465">English</option>
                    <option value="german" data-id="element-466">German</option>
                    <option value="spanish" data-id="element-467">Spanish</option>
                  </select>
                  <ValidationError prefix="Language" field="language" errors={state.errors} data-id="element-468" />
                </div>
                <div data-id="element-469">
                  <label htmlFor="currentLevel" className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-470">
                    Current Level *
                  </label>
                  <select id="currentLevel" name="currentLevel" value={formData.currentLevel} onChange={handleChange} required disabled={state.submitting} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:border-green-600 focus:ring-2 focus:ring-green-200 transition-colors duration-200 outline-none disabled:bg-slate-100" data-id="element-471">
                    <option value="" data-id="element-472">Select your level</option>
                    <option value="complete-beginner" data-id="element-473">Complete Beginner</option>
                    <option value="beginner" data-id="element-474">Beginner (A1)</option>
                    <option value="elementary" data-id="element-475">Elementary (A2)</option>
                    <option value="intermediate" data-id="element-476">Intermediate (B1-B2)</option>
                    <option value="advanced" data-id="element-477">Advanced (C1)</option>
                  </select>
                  <ValidationError prefix="Current Level" field="currentLevel" errors={state.errors} data-id="element-478" />
                </div>
              </div>
              <div data-id="element-479">
                <label htmlFor="preferredSchedule" className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-480">
                  Preferred Schedule
                </label>
                <input type="text" id="preferredSchedule" name="preferredSchedule" value={formData.preferredSchedule} onChange={handleChange} disabled={state.submitting} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:border-green-600 focus:ring-2 focus:ring-green-200 transition-colors duration-200 outline-none disabled:bg-slate-100" placeholder="e.g., Weekday evenings, Weekend mornings" data-id="element-481" />
                <ValidationError prefix="Preferred Schedule" field="preferredSchedule" errors={state.errors} data-id="element-482" />
              </div>
              <div data-id="element-483">
                <label htmlFor="goals" className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-484">
                  Learning Goals *
                </label>
                <textarea id="goals" name="goals" value={formData.goals} onChange={handleChange} required rows={4} disabled={state.submitting} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:border-green-600 focus:ring-2 focus:ring-green-200 transition-colors duration-200 outline-none resize-none disabled:bg-slate-100" placeholder="Tell us about your language learning goals..." data-id="element-485" />
                <ValidationError prefix="Goals" field="goals" errors={state.errors} data-id="element-486" />
              </div>
              <button type="submit" disabled={state.submitting} className="w-full bg-green-600 text-white py-4 rounded-lg font-semibold hover:bg-green-700 transition-all duration-200 shadow-lg hover:shadow-xl disabled:bg-slate-400 disabled:cursor-not-allowed" data-id="element-487">
                {state.submitting ? 'Submitting...' : 'Book Free Assessment'}
              </button>
            </form>}
        </motion.div>
      </div>
    </div>;
}